import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Box from '../components/box/Box'; // Assuming you have a Box component for layout
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './ViewReport.scss'; // Import the SCSS file
import DataTable from '../components/DataTables/datatable'; // Import the DataTable component
import API_URLS from "../summaryapi/apiUrls";
const ViewReport = () => {
    const [serviceProviders, setServiceProviders] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch service providers when the component mounts
    useEffect(() => {
        const fetchServiceProviders = async () => {
            try {
                const response = await fetch(API_URLS.getServiceProviders.url);
                if (!response.ok) {
                    throw new Error('Failed to fetch service providers');
                }

                const result = await response.json();
                if (result.success) {
                    setServiceProviders(result.data);
                } else {
                    toast.error('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Error:', error);
                toast.error('An error occurred while fetching service providers.');
            } finally {
                setLoading(false);
            }
        };

        fetchServiceProviders();
    }, []);

    // Show loading state while data is being fetched
    if (loading) {
        return (
            <Box>
                <h3>Loading Service Providers...</h3>
            </Box>
        );
    }

    // Data table columns for service providers
    const columns = [
        { label: 'Name', key: 'name' },
        { label: 'Email', key: 'email' },
        { label: 'Phone Number', key: 'MobileNo' },
        { label: 'Address', key: 'address' }
    ];

    return (
        <div className="view-report-container">
            <h3 className="page-heading">Service Providers</h3>


            {/* Integrate the DataTable component */}
            <DataTable data={serviceProviders} columns={columns} />
        </div>
    );
};

export default ViewReport;
